import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="file-upload"
export default class extends Controller {
  static targets = ["fileInput", "dropZone", "uploadArea", "previewArea", "fileName", "fileSize", "submitButton", "errorArea", "errorMessage"]
  
  connect() {
    this.maxSize = 10 * 1024 * 1024 // 10MB in bytes
    this.allowedTypes = ['text/csv', 'application/vnd.ms-excel']
  }
  
  triggerFileSelect(event) {
    event.preventDefault()
    this.fileInputTarget.click()
  }
  
  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.processFile(file)
    }
  }
  
  handleDragOver(event) {
    event.preventDefault()
    event.dataTransfer.dropEffect = 'copy'
    this.dropZoneTarget.classList.add('border-primary-400', 'bg-primary-50')
  }
  
  handleDragLeave(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove('border-primary-400', 'bg-primary-50')
  }
  
  handleDrop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove('border-primary-400', 'bg-primary-50')
    
    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.processFile(files[0])
    }
  }
  
  processFile(file) {
    // Clear any previous errors
    this.hideError()
    
    // Validate file type
    const fileExtension = file.name.split('.').pop().toLowerCase()
    if (fileExtension !== 'csv') {
      this.showError('Please select a CSV file')
      return
    }
    
    // Validate file size
    if (file.size > this.maxSize) {
      this.showError('File size must be less than 10MB')
      return
    }
    
    // Update file input (this will be submitted with the form)
    const dataTransfer = new DataTransfer()
    dataTransfer.items.add(file)
    this.fileInputTarget.files = dataTransfer.files
    
    // Show preview
    this.showPreview(file)
  }
  
  showPreview(file) {
    this.fileNameTarget.textContent = file.name
    this.fileSizeTarget.textContent = this.formatFileSize(file.size)
    
    // Show preview, hide upload area
    this.uploadAreaTarget.classList.add('hidden')
    this.previewAreaTarget.classList.remove('hidden')
    
    // Enable submit button
    this.submitButtonTarget.disabled = false
  }
  
  removeFile(event) {
    event.preventDefault()
    
    // Clear file input
    this.fileInputTarget.value = ''
    
    // Show upload area, hide preview
    this.previewAreaTarget.classList.add('hidden')
    this.uploadAreaTarget.classList.remove('hidden')
    
    // Disable submit button
    this.submitButtonTarget.disabled = true
    
    // Clear any errors
    this.hideError()
  }
  
  showError(message) {
    if (this.hasErrorMessageTarget && this.hasErrorAreaTarget) {
      this.errorMessageTarget.textContent = message
      this.errorAreaTarget.classList.remove('hidden')
    }
  }
  
  hideError() {
    if (this.hasErrorAreaTarget) {
      this.errorAreaTarget.classList.add('hidden')
      if (this.hasErrorMessageTarget) {
        this.errorMessageTarget.textContent = ''
      }
    }
  }
  
  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }
}
